var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e32118",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v26.7H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e9a00",
    d: "M.7 0H54v13.3H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0073ce",
    d: "M.7 0v40l15-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.1 16h6.4v6.7c0 2.2-3 .5-3.2 1.7-.4-1.2-3.2.5-3.2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73452b",
    d: "M27.8 23.3h-.2c-.2 0-.2-4.2-.2-4.2l.6-.5.2.1c-.8.4-.7 1-.6 2v1.2l.4 1.3q-.1.2-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73452b",
    d: "M27.3 18.5h.3c-.3 2.4 0 3.8 0 4.5v.3c-.2.4-.4 0-.4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a36629",
    d: "M26.8 23.3q-.4 0-.3-.2c.6-1.2.9-4 .3-4.2v-.3q.5.1.5.3v4.4c-.4.3-.5 0-.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 23.3q-.4 0-.3-.2c.6-1.2.9-4 .3-4.2v-.3q.5.1.5.3v4.4c-.4.3-.5 0-.5 0m0 0 .4-1.7m.4.6.2 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a3b",
    d: "M28.3 17.3h.2c0-.3.5-.3.5 0q.5 0 .3.3.6-.1.5.4c.6.1.3.5.1.6q0 .4-.6.3-.6.3-.8-.1-.5 0-.7-.3h-.7q0 .2-.2 0 0 .6-.4.4c.2.4-.3.6-.6.3q-.2 0-.3-.2-.4.5-.6.1-.6-.1 0-.3.1-.3.4-.2 0-.2.2 0l.1-.3q-.2-.4.2-.5-.1-.2.2-.2-.1-.4.4-.4l.1-.2q-.1-.4.4-.3c0-.4 1-.2.9.4q.3 0 .4.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5 17.2.1.2q.3-.3.3.1m1-.4q-.3 0-.3.3-.2-.2-.4 0m1 0v.3m1 0H29m1 1q0-.2-.3 0 0-.2-.2-.3m0 .5-.1-.3m-.5 0-.3.1m-.7-.2v-.3m-1.9 1 .1-.3m0 0q0-.2-.3 0m.3 0h.3m-.6-.6h.4m0-.4.3.1.3-.2m.4 0 .4.3.3-.2m.6.2q.4 0 .5.2l.3-.1m-2.8.3h.3l.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M27.1 15h-.4l-.1.4-.2-.3H26l.2-.3-.2-.4h.4l.1-.3.2.3h.4l-.2.3zm-1.6.2h-.3l-.1.4-.3-.3-.3.1v-.3l-.2-.3h.4v-.4l.3.2h.4l-.1.3zm-1.5.3-.3.1v.4l-.3-.2-.4.2v-.4l-.2-.2.3-.2V15l.3.2.4-.2v.4zm3.6-.5h.4l.1.4.2-.3h.4l-.2-.3.2-.4h-.3l-.2-.3-.2.3h-.4l.2.3zm1.6.2h.3l.1.4.3-.3.3.1v-.3l.2-.3H30v-.4l-.3.2h-.4l.1.3zm1.5.3.3.1v.4l.3-.2.4.2v-.4l.3-.2-.4-.2V15l-.3.2-.4-.2v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m31.1 22.5.4.6.4-.5-.2-.5zm-2.6 1.8v.6h.3l.3-.2v-.3zm-2.3 0v.6h-.3l-.2-.2-.2-.4zm-2.6-1.8-.5.6-.5-.7.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.6 25.5c0 .6 3.5.6 3.5 0v-.8c0 .4-3.5.3-3.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.6 23.6c.3 1.6 3 1.6 3 1.6v-.5q-.1-.3.5-.3.2-.1.1-.3s-1.2.2-2-.2c-1.2-.4-1.3-1.3-1.3-1.3s-.1.7-.3 1Zm9.5 0c-.3 1.6-3 1.6-3 1.6v-.5q0-.3-.6-.3V24s1.2.2 2-.2c1.1-.4 1.3-1.3 1.3-1.3s.1.7.3 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M22.8 23c-.8-.4-.2-.8-.1-2 .1.7 1 1 .9 1.5-.4 0-.6-.5-.7 0zm9.1 0c.8-.4.1-.8 0-2 0 .7-.9 1-.8 1.5.3 0 .5-.5.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m23.3 23.6-.2.3v.2h.2l.2-.3-.1.3H23q-.2 0 0-.3zm.3.3v.5l.2-.3h.1l-.2.4h-.1v-.4l-.2.3h-.1zm.1.7.3-.5-.2.5m.4-.4-.2.5h.2q.3.1.3-.1l-.1-.3zm0 .1q.3 0 .2.3h-.2zm.5 0-.2.5h.3v.1h.2l-.1-.5zm0 .2.1.2h-.1zm.3 0v.4h.2q.2 0 .3-.2t-.3-.3zm.1 0q.3 0 .2.2t-.2.2zm1.7.6v.6h.1v-.2h.2V25zm.1.1h.1q.2.1 0 .2h-.1zm.5 0-.2.5.1-.1h.4zm0 0 .1.3h-.1zm.3.4.3-.4h-.2.4l-.4.4h.4zm1.7-1v.4H29h.2zm.2 0 .1.3h.2v-.3l.1.2-.1.3q-.2 0-.3-.2zm.5.1h.2zv-.3h.3-.2v.1h.1l.2.2-.2.1zm.4-.4.3-.2v.5zm.3-.2.3.4H31zm.5 0h.1a.2.2 0 0 1-.2.3q-.3-.1-.2-.3 0-.3.3-.1H31v.3q.3 0 .2-.1m0-.3.4.4h-.1zm.3-.2h-.1l.2.5V24l.2-.2h.1zm0 .1h.2l-.1.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/gq.069377065c2ab1f8b133927a04e2ef76.svg";
export { ForwardRef as ReactComponent };